import styles from "./CustomerUpdate.module.scss";
import primaryComponents from "../../primaryComponents";
import { useState } from "react";

const PaymentUpdate = ({ closeModal, orderDetails, updatePaymentMethod }) => {
  const [paymentMethod, setPaymentMethod] = useState(
    orderDetails?.payment_method || "",
  );

  return (
    <div className={styles.customerUpdate}>
      <h4 className="text-center">Update Payment Method</h4>
      <div className="mr-2">
        <label className="small-text-size">Select Payment Method</label>
        <div>
          <primaryComponents.SelectField
            options={[
              { name: "Cash", id: "cash" },
              { name: "Card", id: "card" },
              { name: "Transfer", id: "transfer" },
            ]}
            value={orderDetails?.payment_method}
            placeholder="Select Payment Method"
            floatError={false}
            nameKey="name"
            idKey="id"
            onChange={(value) => {
              setPaymentMethod(value);
            }}
          />
        </div>
      </div>
      <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          onClick={closeModal}
        >
          Cancel
        </primaryComponents.Button>
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          style={{ width: "120px" }}
          onClick={() => {
            updatePaymentMethod({
              orderId: orderDetails?.id,
              value: paymentMethod,
            });
            closeModal();
          }}
          isLoading={false}
          isLoadingText="Updating..."
        >
          Save
        </primaryComponents.Button>
      </div>
    </div>
  );
};

export default PaymentUpdate;
